import {
  LIST_IDS,
  SET_COMMON_ACTION,
  SET_DATE_FIELD_ACTION,
  SET_SIMPLE_NOTAS_FISCAIS_ACTION,
} from './NotasFiscais.constants';

function buildRequestFields() {
  return {
  };
}

function buildInitialStates() {
  return {
    requestFields: buildRequestFields(),
    page: 0,
    rowsPerPage: 10,
    totalElements: 0,
    columnOrdenacao: { element: 'dataNota', order: 'DESC' },
    arrowDirection: true,
    tableView: [],
    resumoNotasFiscais: {
      ativaCliente: 0,
      canceladaCliente: 0,
      foraPrazoCliente: 0,
      ativaDevedor: 0,
      canceladaDevedor: 0,
      foraPrazoDevedor: 0,
    },
    filtrosRequest: {
      cpfCnpj: '',
      numeroRPSNotaFiscal: '',
      nome: '',
      numeroProcesso: '',
      statusNotaFiscal: 'todosStatus',
      tipoNotaFiscal: 'todosTipos',
    },
    periodoInicial: {
      value: '',
      error: false,
      errorMessage: '',
      disabled: false,
    },
    periodoFinal: {
      value: '',
      error: false,
      errorMessage: '',
      disabled: false,
    },
    selectAll: false,
    listIds: {},
    atualizarListaIds: false,
    common: {
      loadingPage: false,
    },
  };
}

function onChangeDateFieldHandler(states, actions) {
  const { name, value } = actions;
  const field = states.requestFields[name].getNewModel(value);

  return {
    ...states,
    requestFields: {
      ...states.requestFields,
      [name]: field,
    },
  };
}

function setSimpleNotasFiscaisHandler(states, actions) {
  const { name, value } = actions;
  return {
    ...states,
    [name]: value,
  };
}

function setCommonHandler(states, actions) {
  const { name, value } = actions;
  return {
    ...states,
    common: {
      ...states.common,
      [name]: value,
    },
  };
}

function setSimpleValuesListIdsHandler(states, actions) {
  const { name, value } = actions;
  return {
    ...states,
    listIds: {
      ...states.listIds,
      [name]: value,
    },
  };
}

export const onChangeDateFieldAction = (name, value) => ({
  type: SET_DATE_FIELD_ACTION,
  name,
  value,
});

export const setSimpleNotasFiscaisAction = (name, value) => ({
  type: SET_SIMPLE_NOTAS_FISCAIS_ACTION,
  name,
  value,
});

export const setCommonAction = (name, value) => ({
  type: SET_COMMON_ACTION,
  name,
  value,
});

export const setSimpleValuesListIdsAction = (name, value) => ({
  type: LIST_IDS,
  name,
  value,
});

export default (states = buildInitialStates(), actions) => {
  switch (actions.type) {
    case SET_DATE_FIELD_ACTION:
      return onChangeDateFieldHandler(states, actions);
    case SET_SIMPLE_NOTAS_FISCAIS_ACTION:
      return setSimpleNotasFiscaisHandler(states, actions);
    case SET_COMMON_ACTION:
      return setCommonHandler(states, actions);
    case LIST_IDS:
      return setSimpleValuesListIdsHandler(states, actions);
    default:
      return states;
  }
};
